import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { LayoutOuter, LayoutContent, NavBar, LayoutContentInner, } from './Wrapper.style';
import Header from './Header';
const Wrapper = ({ children, hasheader = true }) => {
    return (_jsxs(LayoutOuter, { children: [hasheader && (_jsx(NavBar, { children: _jsx(Header, {}) })), _jsx(LayoutContent, { children: _jsx(LayoutContentInner, { children: children }) })] }));
};
export default Wrapper;
